module.exports = {"430603001":"长岭街道","430603100":"云溪镇","430603101":"陆城镇","430603102":"路口镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430603.json
// module id = 1700
// module chunks = 0